import { render, staticRenderFns } from "./BranchSelectionReview.vue?vue&type=template&id=59919a78"
import script from "./BranchSelectionReview.vue?vue&type=script&lang=js"
export * from "./BranchSelectionReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports